import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  InputLabel,
  Paper,
  Select,
  MenuItem
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { addOutletUser } from "../../app/services/OutletUserService";
import { fetchOrganisation, Organisation } from "../../app/services/OrganisationService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
//import { fetchStates, States } from "../../app/services/StatesService";
//import { fetchCitiesByState, City } from "../../app/services/CitiesService";
import { fetchOutletByOrganisation, Outlet } from "../../app/services/OutletService";
import { fetchUserRole } from "../../app/services/OutletUserService";
import { USER_TYPES } from "../../app/api/constants";

const AddOutlet = () => {
  const [name, setName] = useState("");
  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  
  const navigate = useNavigate();
  
  const [organisationList, setOrganisationList] = useState<Organisation[]>([]);
  const [selectedOrganisation, setSelectedOrganisation] = useState("");

  const [outletList, setOutletList] = useState<Outlet[]>([]);
  const [selectedOutlet, setSelectedOutlet] = useState("");

  const [roleList, setRoleList] = useState<{ id: number; name: string }[]>([]);
  const [selectedRole, setSelectedRole] = useState<{ id: number; name: string } | null>(null);

  const handleReset = () => {
    setName("");
    
    setEmail("");
    //setMobile("");
    
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      toast("Name is required");
      return;
    }
    
    if (!email.trim()) {
      toast("Email is required");
      return;
    }
    const payload = {
                  name,
                  org_id: selectedOrganisation,
                  outlet_id: selectedRole?.name === USER_TYPES.USER ? selectedOutlet : null,
                  email,
                  password,
                  role_id: selectedRole?.id,
                  
      };

    try {
      const response = await addOutletUser(payload);
      if (response.data.status === "success") {
        toast("User saved successfully!");
        handleReset();
        navigate("/organisation/outlet/user");
      } else {
        toast(response.data.message);
      }
    } catch (error) {
      toast("Failed to save User.");
    }
  };


  useEffect(() => {
    const loadOrganisation = async () => {
      try {
        const res = await fetchOrganisation();
        if (res.status === "success") {
          setOrganisationList(res.data); 
        }
      } catch (err) {
        toast("Failed to load organisation");
      }
    };
  
    loadOrganisation();
  }, []);

  
  useEffect(() => {
  if (!selectedOrganisation) return;

  const loadOutlet = async () => {
    try {
      const res = await fetchOutletByOrganisation(Number(selectedOrganisation));
      if (res?.status === "success") {
        setOutletList(res.data);
      }
    } catch (err) {
      toast("Failed to load outlet");
    }
  };

  loadOutlet();
}, [selectedOrganisation]);

  useEffect(() => {
  const loadRoles = async () => {
    try {
      const res = await fetchUserRole({});
      if (res?.status === "success") {
        setRoleList(res.data);
      }
    } catch (err) {
      toast("Failed to load user roles");
    }
  };

  loadRoles();
}, []);

  return (
    <Box
      minHeight="20vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="#f9f9f9" 
    >
      <Paper
        elevation={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: 4,
          p: 5,
          width: "100%",
          maxWidth: 900, 
        }}
      >
        <Typography
          variant="h5"
          fontWeight={700}
          mb={4}
          color="primary"
          textAlign="center"
        >
          Add New Outlet User
        </Typography>

       
        <Box mb={3}>
          <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
            Organisation <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <Select
            fullWidth
            displayEmpty
            value={selectedOrganisation}
            onChange={(e) => setSelectedOrganisation(e.target.value)}
          >
            <MenuItem value="" disabled>Select a organisation</MenuItem>
            {organisationList.map((org) => (
              <MenuItem key={org.id} value={org.id}>
                {org.name}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <Box mb={3}>
          <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
            User Role <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <Select
            fullWidth
            displayEmpty
            value={selectedRole?.id || ""}
            onChange={(e) => {
              const selected = roleList.find((role) => role.id === e.target.value);
              setSelectedRole(selected || null);
            }}
          >
            <MenuItem value="" disabled>Select a role</MenuItem>
            {roleList
              .filter((role) => role.name.toLowerCase() !== "super admin")
              .map((role) => (
                <MenuItem key={role.id} value={role.id}>
                  {role.name}
                </MenuItem>
            ))}
          </Select>
        </Box>

        {(selectedRole?.name === USER_TYPES.ADMIN || selectedRole?.name === USER_TYPES.USER) && (
        <Box mb={3}>
          <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
            Outlet <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <Select
            fullWidth
            displayEmpty
            value={selectedOutlet}
            onChange={(e) => setSelectedOutlet(e.target.value)}
            disabled={!outletList.length}
          >
            <MenuItem value="" disabled>Select an outlet</MenuItem>
            {outletList.map((out) => (
              <MenuItem key={out.id} value={out.id}>
                {out.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}

        <Box mb={3}>
          <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
            Name <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <TextField
            fullWidth
            size="medium"
            placeholder="Enter name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Box>
        <Box mb={3}>
          <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
            Email <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <TextField
            fullWidth
            size="medium"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Box>

        <Box mb={3}>
          <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
            Password <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <TextField
            fullWidth
            size="medium"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Box>

      
        <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
          <Button
            variant="outlined"
            onClick={handleReset}
            sx={{
              px: 4,
              py: 1.2,
              fontWeight: 600,
              borderColor: "#fcb500",
              color: "#fcb500",
              "&:hover": {
                backgroundColor: "#fff8e1",
                borderColor: "#fcb500",
              },
            }}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              px: 4,
              py: 1.2,
              backgroundColor: "#fcb500",
              color: "#000",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#fbc02d",
              },
            }}
          >
            Save
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default AddOutlet;
